const PATH = 'fe.pages.organization.invite_new_users';

const messages = {
  new: {
    key: `${PATH}.new`,
    defaultValue: 'Invite New Users'
  },
  inviteUsers: {
    key: `${PATH}.invite_users`,
    defaultValue: 'Invite Users'
  },
  emailPlaceholder: {
    key: `${PATH}.email_placeholder`,
    defaultValue: 'Enter email address'
  },
  role: {
    key: `${PATH}.role`,
    defaultValue: 'Role'
  },
  rolePlaceholder: {
    key: `${PATH}.role_placeholder`,
    defaultValue: 'Select role'
  },
  errors: {
    email: {
      key: `${PATH}.errors.email`,
      defaultValue: 'You must provide a valid email address'
    },
    required: {
      key: `${PATH}.errors.required`,
      defaultValue: 'This field is required'
    },
    invited: {
      key: `${PATH}.errors.invited`,
      defaultValue: 'User {{name}} ({{role}}) already invited.'
    },
    accepted: {
      key: `${PATH}.errors.subscribed`,
      defaultValue: 'User {{name}} ({{role}}) is already subscribed.'
    },
    uploaded: {
      key: `${PATH}.errors.uploaded`,
      defaultValue: 'User {{name}} ({{role}}) was uploaded via CSV.'
    },
    error: {
      key: `${PATH}.errors.error`,
      defaultValue: 'Error checking subscription. Please try again later.'
    },
    notAccountUser: {
      key: `${PATH}.errors.not_account_user`,
      defaultValue: 'Only account members can be invited.'
    },
    notVisible1: {
      key: `${PATH}.errors.not_visible`,
      defaultValue: 'You must'
    },
    notVisible2: {
      key: `${PATH}.errors.not_visible2`,
      defaultValue: 'add this member to your hierarchy'
    },
    notVisible3: {
      key: `${PATH}.errors.not_visible3`,
      defaultValue: 'to invite them to the subscription'
    },
    adminHint1: {
      key: `${PATH}.errors.admin_hint1`,
      defaultValue: 'You may need to'
    },
    adminHint2: {
      key: `${PATH}.errors.admin_hint2`,
      defaultValue: 'add this member to your hierarchy'
    },
    adminHint3: {
      key: `${PATH}.errors.admin_hint3`,
      defaultValue: 'to view them.'
    }
  },
  back: {
    key: `${PATH}.back`,
    defaultValue: 'Back to Learning Resources'
  },
  addAnotherUser: {
    key: `${PATH}.add_another_user`,
    defaultValue: 'Invite Another User'
  },
  deleteForm: {
    key: `${PATH}.delete_form`,
    defaultValue: 'Delete Form'
  },
  userInvited: {
    key: `${PATH}.user_invited`,
    defaultValue: '{{count}} invite(s) sent'
  },
  clearForm: {
    key: `${PATH}.clear_form`,
    defaultValue: 'Clear Form'
  },
  goBack: {
    key: `${PATH}.go_back`,
    defaultValue: 'Go Back'
  }
};

export default messages;
